import React from "react"
import {BrowserRouter as Router, Route, Routes} from "react-router-dom"
import Login from "./pages/Login/Login"
import {AuthProvider} from "./services/auth"
import {ModalProvider} from "react-modal-hook"
import {CookiesProvider} from "react-cookie"
import LoginSSO from "./pages/Login/LoginSSO"
import SignUp from "./pages/SignUp/SignUp"
import {PermissionProvider} from "./services/permission"
import {isSandboxEnv, isSandboxOrLocalEnv} from "./utilities/environment"
import {useHotjar} from "./hooks/UseHotjar"
import useCommonRoom from "./hooks/useCommonRoom"
import {AuthenticatedDefaultLayout} from "./containers/DefaultLayout/DefaultLayout"
import {BulmaToastProvider} from "./components/BulmaToast/BulmaToast"
import {ClaimsProvider} from "./services/claims"
import MFA from "./pages/Login/LoginMFA"
import {OrgBankingSetupProvider} from "./services/orgBankingSetup"
import LoginBiometric from "./pages/Login/LoginBiometric"
import {TimezoneProvider} from "./services/timezone"

export default function App() {
	useHotjar(isSandboxEnv())
	useCommonRoom(isSandboxEnv())

	return (
		<CookiesProvider>
			<TimezoneProvider>
				<AuthProvider>
					<ClaimsProvider>
						<PermissionProvider>
							<BulmaToastProvider>
								<ModalProvider>
									<Router>
										<Routes>
											<Route path="/login/two-factor" element={<MFA />} />
											<Route path="/login/*" element={<Login />} />
											<Route path="/sso" element={<LoginSSO />} />
											<Route path="/biometric" element={<LoginBiometric />} />
											{isSandboxOrLocalEnv() && <Route path="/signup" element={<SignUp />} />}
											<Route
												path="/*"
												element={
													<OrgBankingSetupProvider>
														<AuthenticatedDefaultLayout />
													</OrgBankingSetupProvider>
												}
											/>
										</Routes>
									</Router>
								</ModalProvider>
							</BulmaToastProvider>
						</PermissionProvider>
					</ClaimsProvider>
				</AuthProvider>
			</TimezoneProvider>
		</CookiesProvider>
	)
}
